import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './CrosshairIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const CrosshairIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function CrosshairIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 14 14" component={Icon} {...props} />
  );
});
